import { useNavigate, useSearchParams } from "react-router-dom";
import { DialogContent } from "@mui/material";
import { useTranslation } from "react-i18next";

//import general components
import SignIn from "../../../pages/signin-signup/signIn";
import BaseDialog from "../base-dialog/base-dialog";

function LoginModal({ open, setOpen }) {
    //general variables
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const { t } = useTranslation();

    //handle close modal
    const handleClose = () => {
        setOpen(false);
        navigate(-1);
        searchParams.delete("action");
        setSearchParams(searchParams);
    };

    return (
        <BaseDialog title={t("signin")} open={open} handleClose={handleClose} maxWidth="xs" top="auto" icon="close">
            <DialogContent dividers={true}>
                <SignIn handleClose={handleClose} />
            </DialogContent>
        </BaseDialog>
    );
}

export default LoginModal;
